import * as StellarSdk from '@stellar/stellar-sdk';

import { AMM_TOKENS_LIST } from 'constants/local-storage';

import { getNetworkPassphrase } from 'helpers/env';

import { ClassicToken, Token, TokenType } from 'types/token';

// Contract ordering is byte ordering, not the lexicographic order of StrKeys.
export const sortTokenIds = (contracts: string[]): string[] =>
    [...contracts].sort((a, b) =>
        Buffer.compare(StellarSdk.StrKey.decodeContract(a), StellarSdk.StrKey.decodeContract(b)),
    );

export const createLumen = (): ClassicToken => {
    const asset: ClassicToken = StellarSdk.Asset.native() as ClassicToken;

    asset.type = TokenType.classic;
    asset.contract = asset.contractId(getNetworkPassphrase());
    asset.decimal = 7;

    return asset;
};

export const createAsset = (code: string, issuer: string): ClassicToken => {
    if (code === 'XLM' && !issuer) {
        return createLumen();
    }
    const asset: ClassicToken = new StellarSdk.Asset(code, issuer) as ClassicToken;

    asset.type = TokenType.classic;
    asset.contract = asset.contractId(getNetworkPassphrase());
    asset.decimal = 7;

    return asset;
};

export const cacheTokens = (tokens: Token[]) => {
    try {
        localStorage.setItem(AMM_TOKENS_LIST, JSON.stringify(tokens));
    } catch {
        // A full or disabled cache must not prevent loading the token picker.
    }
};

export const getTokensFromCache = (): Token[] | null => {
    const tokens = JSON.parse(localStorage.getItem(AMM_TOKENS_LIST));

    if (!tokens) return null;

    const lumen = createLumen();
    return tokens.map(token => {
        if (token.type === TokenType.soroban) {
            return token;
        }

        return lumen.contract === token.contract ? lumen : createAsset(token.code, token.issuer);
    });
};
